export default __webpack_public_path__ + "static/media/hht2_ep08_timeline_q02_b.0409057d.png";